import { render, staticRenderFns } from "./radio-v3.vue?vue&type=template&id=3541d9f8"
import script from "./radio-v3.js?vue&type=script&lang=js&external"
export * from "./radio-v3.js?vue&type=script&lang=js&external"
import style0 from "./radio-v3.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports